import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const teamRec = {
    crewSubtitle: null,
    crewList: [
        {
            crewItemTitle: 'Анастасия Андронова',
            crewItemSubtitle: 'руководитель подразделения Вебпрактик.Маркетинг',
        },
        {
            crewItemTitle: 'Ольга Федорова',
            crewItemSubtitle: 'руководитель проекта',
        },
        {
            crewItemTitle: 'Ксения Жукова',
            crewItemSubtitle: 'старший менеджер проектов',
        },
        {
            crewItemTitle: 'Евгения Шестакова',
            crewItemSubtitle: 'руководитель отдела контекстной рекламы',
        },
        {
            crewItemTitle: 'Вадим Шапошников',
            crewItemSubtitle: 'руководитель отдела SEO',
        },
        {
            crewItemTitle: 'Александр Сидоров',
            crewItemSubtitle: 'старший специалист поискового продвижения',
        },
        {
            crewItemTitle: 'Дмитрий Торлаков',
            crewItemSubtitle: 'специалист по контекстной рекламе',
        },
        {
            crewItemTitle: 'Эрик Сон',
            crewItemSubtitle: 'специалист по контекстной рекламе',
        },
    ],
};

const Team = () => {
    return (
        <FullWrapper caseName="gens-team">
            <CommonTitle>Команда</CommonTitle>
            <CrewContainer container={teamRec} />
        </FullWrapper>
    );
};

export default Team;
